import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-191808e8")

_pushScopeId("data-v-191808e8")
const _hoisted_1 = {
  class: "r-grid bread-crumb",
  "aria-label": "Breadcrumb"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, " > ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Manage Employees ")
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, " > ", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" HR Admin ")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, " > ", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, " > ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode("ol", null, [
      _createVNode("li", null, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _createVNode("li", null, [
        (_ctx.managedEmployeesPage)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/manage-employees"
            }, {
              default: _withId(() => [
                _hoisted_3,
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode("li", null, [
        (_ctx.$route.name === 'Add User'
        || _ctx.$route.name === 'View/Edit User'
        || _ctx.$route.name === 'Reports'
        || _ctx.$route.name === 'Banner Upload')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: `/hr-admin/`
            }, {
              default: _withId(() => [
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (_ctx.lookUpUserInfoData)
        ? (_openBlock(), _createBlock("li", _hoisted_7, [
            (_ctx.$route.name === 'Manage Single Employee'
        || _ctx.$route.name === 'Employee Leave Item'
        || _ctx.$route.name === 'Employee Leave Balance')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: `/manage-employees/${ _ctx.$route.params.uin }`
                }, {
                  default: _withId(() => [
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(_ctx.lookUpUserInfoData.name), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode("li", null, [
        (_ctx.$route.name !== 'Home'
        && _ctx.$route.name !== 'Manage Employees'
        && _ctx.$route.name !== 'Manage Single Employee')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: _ctx.$route.fullPath
            }, {
              default: _withId(() => [
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(_ctx.$route.name), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})